import type { Components } from '@/api/generated/api';

type ReportListParams = {
  classId?: number;
  currentPage: number;
  groupId?: number | null;
  pageSize: number;
  searchText: string;
  sortOption: string;
  status?: Components.Schemas.ReportStatus | null;
  studentId?: number | null;
};

export const reportKeys = {
  all: ['report'],

  lists: () => [...reportKeys.all, 'list'],

  classLists: (classId?: number) => {
    if (classId == null) return reportKeys.lists();
    return [...reportKeys.lists(), classId];
  },

  list: (params: ReportListParams) => [
    ...reportKeys.lists(),
    params.classId ?? null,
    params.currentPage,
    params.pageSize,
    params.searchText,
    params.status ?? null,
    params.sortOption,
    params.groupId ?? null,
    params.studentId ?? null,
  ],

  creationInterval: (classId?: number) => [...reportKeys.all, 'creationInterval', classId ?? null],

  completedGroupIds: (classId?: number, groupId?: number) => [
    ...reportKeys.classLists(classId),
    'completedGroupIds',
    groupId ?? null,
  ],
};
